import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly snackbar   = inject(MatSnackBar);

  error(message: string): void {
    this.show(message, 'cb-toast--error', 4000);
  }

  success(message: string): void {
    this.show(message, 'cb-toast--success', 3000);
  }

  info(message: string): void {
    this.show(message, 'cb-toast--info', 3000);
  }

  private show(message: string, variant: string, duration: number): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.snackbar.open(message, undefined, {
      duration,
      panelClass:         ['cb-toast', variant],
      horizontalPosition: 'center',
      verticalPosition:   'top',
    });
  }
}
